let paymentData = {
  _id: "",
  totalWithoutTaxes: 0.0,
  discountValue: 0.0,
  discountAmount : 0,
  discountType: "",
  totalAfterDiscount: 0.0,
  taxes: [],
  totalTaxes: 0.0,
  totalWithTaxes: 0.0,
  totalWithServices: 0.0,
  roundValue: 0.0,
  roundedTotalWithServices: 0.0,
  deposit: 0.0,
  payableAmount: 0.0,
  depositMethod: "",
  cashAmount: 0.0,
  balance: 0.0,
  method: "",
  transactionId: "",
  invoiceId: "",
  remarks: null,
  currentCashierName: ""
};

let validationData = {
  isValidated: false,
  selectedTable: 0,
};

export const setPaymentData = (
  totalWithoutTaxes,
  discount,
  discountAmount,
  discountType,
  totalAfterDiscount,
  taxes,
  totalTaxes,
  totalWithTaxes,
  totalWithServices,
  rounding,
  roundedTotalWithServices,
  deposit,
  payableAmount,
  depositMethod,
  cashAmount,
  balance,
  paymentMethod,
  transactionId,
  newestInvoiceId,
  remarks,
  currentCashierName,
   _id,
) => {
  paymentData._id = _id;
  paymentData.totalWithoutTaxes = totalWithoutTaxes;
  paymentData.discount = discount;
  paymentData.discountAmount = discountAmount;
  paymentData.discountType = discountType;
  paymentData.totalAfterDiscount = totalAfterDiscount;
  paymentData.taxes = taxes;
  paymentData.totalTaxes = totalTaxes;
  paymentData.totalWithTaxes = totalWithTaxes;
  paymentData.totalWithServices = totalWithServices;
  paymentData.rounding = rounding;
  paymentData.roundedTotalWithServices = roundedTotalWithServices;
  paymentData.deposit = deposit;
  paymentData.payableAmount = payableAmount;
  paymentData.depositMethod = depositMethod;
  paymentData.cashAmount = cashAmount;
  paymentData.balance = balance;
  paymentData.method = paymentMethod;
  paymentData.transactionId = transactionId;
  paymentData.invoiceId = newestInvoiceId;
  paymentData.remarks = remarks;
  paymentData.currentCashierName = currentCashierName; 
};

export const getPaymentData = () => {
  return paymentData;
};

export const setIsValidated = (validation, table) => {
  validationData.isValidated = validation;
  validationData.selectedTable = table;
};

export const getIsValidated = () => {
  return validationData;
};
